module.exports = __webpack_public_path__ + "static/media/bnr13.68c5681d.jpg";